import { createSlice } from "@reduxjs/toolkit";

import {
  providerScoreCardAnnualCertificationReport,
  providerScoreCardArticlesReadReport,
  providerScoreCardContestParticipationReport,
  providerScoreCardProgramsCompletedReport,
  providerScoreCardQuestionAccuracyReport,
  providerScoreCardQuestionAnsweredReport,
  providerScoreCardVideosWatchedReport,
  userReportData,
  clinicalPerformanceReport,
  clinicLevelPerformanceReport,
  getOrganisationAvailableReports,
  getReportUrlFromName,
} from "../../actions/reports/reportsData";

const initialState = {
  userTracker: null,
  isReportLoading: false,
  questionAccuracy: null,
  questionAnswered: null,
  contestParticipation: null,
  annualCertification: null,
  videosWatchedReport: null,
  articlesReadReport: null,
  programsCompletedReport: null,
  clinicalPerformance: null,
  clinicLevelPerformance: null,
  isOrganisationReportsLoading: false,
  isOrganisationReportsError: false,
  isOrganisationReportUrlLoading: false,
  isOrganisationReportUrlError: false,
  organisationReportUrl: null,
  organisationLevelReports: null,
  organisationLevelReportName: null,
};

export const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {},
  extraReducers: {
    [userReportData.pending]: (state) => {
      state.isReportLoading = true;
    },
    [userReportData.fulfilled]: (state, { payload }) => {
      state.isReportLoading = false;
      state.userTracker = payload;
    },
    [userReportData.rejected]: (state, { payload }) => {
      state.isReportLoading = false;
    },
    [providerScoreCardQuestionAccuracyReport.pending]: (state, action) => {
      state.isReportLoading = true;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.questionAccuracy = null;
    },
    [providerScoreCardQuestionAccuracyReport.fulfilled]: (state, action) => {
      state.isReportLoading = false;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.questionAccuracy = action.payload;
    },
    [providerScoreCardQuestionAccuracyReport.rejected]: (state, action) => {
      state.isReportLoading = false;
      state.questionAccuracy = action.payload;
    },
    [providerScoreCardQuestionAnsweredReport.pending]: (state, action) => {
      state.isReportLoading = true;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.questionAnswered = null;
    },
    [providerScoreCardQuestionAnsweredReport.fulfilled]: (state, action) => {
      state.isReportLoading = false;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.questionAnswered = action.payload;
    },
    [providerScoreCardQuestionAnsweredReport.rejected]: (state, action) => {
      state.isReportLoading = false;
      state.questionAnswered = action.payload;
    },
    [providerScoreCardContestParticipationReport.pending]: (state, action) => {
      state.isReportLoading = true;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.contestParticipation = null;
    },
    [providerScoreCardContestParticipationReport.fulfilled]: (
      state,
      action
    ) => {
      state.isReportLoading = false;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.contestParticipation = action.payload;
    },
    [providerScoreCardContestParticipationReport.rejected]: (state, action) => {
      state.isReportLoading = false;
      state.contestParticipation = action.payload;
    },
    [providerScoreCardAnnualCertificationReport.pending]: (state, action) => {
      state.isReportLoading = true;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.annualCertification = null;
    },
    [providerScoreCardAnnualCertificationReport.fulfilled]: (state, action) => {
      state.isReportLoading = false;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.annualCertification = action.payload;
    },
    [providerScoreCardAnnualCertificationReport.rejected]: (state, action) => {
      state.isReportLoading = false;
      state.annualCertification = action.payload;
    },
    [providerScoreCardVideosWatchedReport.pending]: (state, action) => {
      state.isReportLoading = true;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.videosWatchedReport = null;
    },
    [providerScoreCardVideosWatchedReport.fulfilled]: (state, action) => {
      state.isReportLoading = false;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.videosWatchedReport = action.payload;
    },
    [providerScoreCardVideosWatchedReport.rejected]: (state, action) => {
      state.isReportLoading = false;
      state.videosWatchedReport = action.payload;
    },
    [providerScoreCardArticlesReadReport.pending]: (state, action) => {
      state.isReportLoading = true;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.articlesReadReport = null;
    },
    [providerScoreCardArticlesReadReport.fulfilled]: (state, action) => {
      state.isReportLoading = false;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.articlesReadReport = action.payload;
    },
    [providerScoreCardArticlesReadReport.rejected]: (state, action) => {
      state.isReportLoading = false;
      state.articlesReadReport = action.payload;
    },
    [providerScoreCardProgramsCompletedReport.pending]: (state, action) => {
      state.isReportLoading = true;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.programsCompletedReport = null;
    },
    [providerScoreCardProgramsCompletedReport.fulfilled]: (state, action) => {
      state.isReportLoading = false;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.programsCompletedReport = action.payload;
    },
    [providerScoreCardProgramsCompletedReport.rejected]: (state, action) => {
      state.isReportLoading = false;
      state.programsCompletedReport = action.payload;
    },
    [clinicalPerformanceReport.pending]: (state, action) => {
      state.isReportLoading = true;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.clinicalPerformance = null;
    },
    [clinicalPerformanceReport.fulfilled]: (state, action) => {
      state.isReportLoading = false;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.clinicalPerformance = action.payload;
    },
    [clinicalPerformanceReport.rejected]: (state, action) => {
      state.isReportLoading = false;
      state.clinicalPerformance = action.payload;
    },
    [clinicLevelPerformanceReport.pending]: (state, action) => {
      state.isReportLoading = true;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.clinicLevelPerformance = null;
    },
    [clinicLevelPerformanceReport.fulfilled]: (state, action) => {
      state.isReportLoading = false;
      if (action.meta.arg.type === "export") {
        return;
      }
      state.clinicLevelPerformance = action.payload;
    },
    [clinicLevelPerformanceReport.rejected]: (state, action) => {
      state.isReportLoading = false;
      state.clinicLevelPerformance = action.payload;
    },
    [getOrganisationAvailableReports.pending]: (state) => {
      state.isOrganisationReportsLoading = true;
      state.isOrganisationReportsError = false;
    },
    [getOrganisationAvailableReports.fulfilled]: (state, action) => {
      state.isOrganisationReportsLoading = false;
      state.organisationLevelReports = action.payload;
      if (action.payload?.results.length > 0) {
        state.organisationLevelReportName = action.payload.results.reduce(
          (acc, curr) => {
            acc[curr.name] = false;
            return acc;
          },
          {}
        );
      }
      state.isOrganisationReportsError = false;
    },
    [getOrganisationAvailableReports.rejected]: (state) => {
      state.isOrganisationReportsLoading = false;
      state.organisationLevelReports = null;
      state.isOrganisationReportsError = true;
    },
    [getReportUrlFromName.pending]: (state) => {
      state.isOrganisationReportUrlLoading = true;
      state.isOrganisationReportUrlError = false;
    },
    [getReportUrlFromName.fulfilled]: (state, action) => {
      state.isOrganisationReportUrlLoading = false;
      state.organisationReportUrl = action.payload?.embed_url;
      state.isOrganisationReportUrlError = false;
    },
    [getReportUrlFromName.rejected]: (state, action) => {
      state.isOrganisationReportUrlLoading = false;
      state.organisationReportUrl = null;
      state.isOrganisationReportUrlError = action.payload?.error;
    },
  },
});

export const { profile } = reportsSlice.actions;

export default reportsSlice.reducer;
